/**
 * Token LP (par V2): nombre y símbolo en UI.
 * Deben coincidir con `name` y `symbol` en `UniswapV2ERC20.sol` del fork v2-core
 * (`Nutri-Matic V2` / `NUTRI-V2`). El `name` define el dominio EIP-712 de Permit al retirar liquidez.
 * Ver docs/500-guias/personalizacion-cadena-y-marca.md (`LP_PAIR_LABEL` / `EIP712_PERMIT_DOMAIN_NAME`).
 */
export const LP_PAIR_SYMBOL = 'NUTRI-V2'
export const LP_PAIR_NAME = 'Nutri-Matic V2'
